var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.582 18.4194L14.7914 14.7914L18.4194 13.582L17.21 17.21L13.582 18.4194Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16C3 8.82 8.82 3 16 3C23.18 3 29 8.82 29 16C29 23.18 23.18 29 16 29C8.82 29 3 23.18 3 16ZM20.9493 12.316C21.0084 12.1396 21.017 11.9503 20.9744 11.7692C20.9317 11.5882 20.8394 11.4226 20.7078 11.2912C20.5762 11.1597 20.4105 11.0676 20.2294 11.0251C20.0483 10.9826 19.859 10.9914 19.6827 11.0507L13.6827 13.0507C13.5356 13.1001 13.4021 13.183 13.2926 13.293C13.1832 13.4029 13.1008 13.5368 13.052 13.684L11.052 19.684C10.9936 19.86 10.9853 20.0488 11.0281 20.2293C11.0708 20.4098 11.1629 20.5748 11.294 20.706C11.4252 20.8371 11.5902 20.9292 11.7707 20.9719C11.9512 21.0147 12.14 21.0064 12.316 20.948L18.316 18.948C18.4631 18.8989 18.5968 18.8162 18.7065 18.7065C18.8162 18.5968 18.8989 18.4631 18.948 18.316L20.9493 12.316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigatorIcon);
export default __webpack_public_path__ + "static/media/navigatorIcon.7d655e10b0e3696bb9e9977946522441.svg";
export { ForwardRef as ReactComponent };